import React from "react";
import { Helmet } from "react-helmet";
import GetInTouchBanner from "../components/getintouchbanner";
import Services from "../components/services";
import Location from "../components/location";

import pathway_plain from "../assets/pathway_plain.webp";

export default function Home() {
  return (
    <div className="App bg-gradient-to-b from-white via-blue-50/30 to-white font-nunito">
      <Helmet>
        <link rel="icon" href="favicon.ico" />
      </Helmet>

      {/* Hero Section - Modern, Warm, Welcoming */}
      <section className="relative min-h-[85vh] overflow-hidden bg-gradient-to-br from-[#457B9D] via-[#5a8dad] to-[#6ba3c4]">
        {/* Decorative Elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 h-96 w-96 rounded-full bg-white blur-3xl"></div>
          <div className="absolute bottom-0 left-0 h-96 w-96 rounded-full bg-white blur-3xl"></div>
        </div>

        {/* Content Container */}
        <div className="relative mx-auto flex min-h-[85vh] max-w-7xl flex-col items-center justify-center px-6 py-16 lg:flex-row lg:gap-12 lg:px-12">
          {/* Left Side - Message */}
          <div className="flex flex-1 flex-col items-center justify-center text-center lg:items-start lg:text-left">
            <div className="mb-8 inline-block">
              <h1 className="mb-4 text-4xl font-semibold leading-tight text-white lg:text-5xl xl:text-6xl">
                You're Not Alone
                <span className="mt-2 block text-2xl font-normal text-blue-100 lg:text-3xl">
                  We're here to walk with you
                </span>
              </h1>
            </div>

            <div className="max-w-2xl">
              <blockquote className="relative rounded-3xl bg-white/10 p-8 backdrop-blur-sm">
                <div className="absolute -left-2 -top-2 h-8 w-8 rounded-full bg-white/20"></div>
                <div className="absolute -bottom-2 -right-2 h-8 w-8 rounded-full bg-white/20"></div>

                <p className="text-base leading-relaxed text-white/95 lg:text-lg">
                  "Life is full of choices that carry us down paths leading to different
                  destinations. It is Pathway Resource Center's hope to make the better
                  path more obvious by providing knowledge and understanding of choices
                  and the consequences of those choices BEFORE they are made and the
                  journey begins."
                </p>
                <footer className="mt-4 text-sm text-blue-100">
                  — Pathway Resource Center
                </footer>
              </blockquote>
            </div>

            {/* CTA Buttons */}
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <a
                href="/contact"
                className="group relative overflow-hidden rounded-full bg-white px-8 py-4 font-medium text-[#457B9D] shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                <span className="relative z-10">Get Support Now</span>
                <div className="absolute inset-0 -z-0 bg-gradient-to-r from-blue-50 to-white opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
              </a>
              <a
                href="/pregnancy-services"
                className="rounded-full border-2 border-white/50 px-8 py-4 font-medium text-white backdrop-blur-sm transition-all duration-300 hover:border-white hover:bg-white/10"
              >
                Explore Services
              </a>
            </div>
          </div>

          {/* Right Side - Visual Element */}
          <div className="mt-12 flex flex-1 items-center justify-center lg:mt-0">
            <div className="relative">
              {/* Decorative circles */}
              <div className="absolute -left-6 -top-6 h-24 w-24 rounded-full bg-white/10 blur-xl"></div>
              <div className="absolute -bottom-6 -right-6 h-32 w-32 rounded-full bg-white/10 blur-xl"></div>

              {/* Logo/Image Container */}
              <div className="relative overflow-hidden rounded-3xl bg-white/10 p-8 backdrop-blur-sm shadow-2xl">
                <img
                  src={pathway_plain}
                  alt="Pathway Resource Center"
                  className="h-auto w-full max-w-md object-contain drop-shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Wave Divider */}
        <div className="absolute bottom-0 left-0 w-full">
          <svg
            viewBox="0 0 1440 120"
            className="w-full"
            preserveAspectRatio="none"
            style={{ height: '80px' }}
          >
            <path
              d="M0,64 C360,120 720,0 1440,64 L1440,120 L0,120 Z"
              fill="white"
              opacity="0.3"
            />
            <path
              d="M0,80 C360,20 720,100 1440,80 L1440,120 L0,120 Z"
              fill="white"
            />
          </svg>
        </div>
      </section>

      {/* Get In Touch Banner */}
      <GetInTouchBanner />

      {/* Services Section */}
      <Services />

      {/* Location */}
      <Location />

      {/* Scripture Verse Footer */}
      <section className="bg-gradient-to-br from-blue-50 to-white py-16">
        <div className="mx-auto max-w-3xl px-6 text-center">
          <div className="rounded-3xl bg-white p-8 shadow-lg">
            <div className="mb-4 inline-block rounded-full bg-[#457B9D]/10 px-4 py-2">
              <span className="text-sm font-medium text-[#457B9D]">
                Our Foundation
              </span>
            </div>
            <p className="text-lg leading-relaxed text-gray-700">
              "Carefully consider the path for your feet, and all your ways will be
              established."
            </p>
            <p className="mt-3 text-sm font-medium text-gray-500">
              Proverbs 4:26
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
